"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
const commentCard_1 = __importDefault(require("./commentCard"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const themes_1 = __importDefault(require("../../styles/themes"));
const ticketSlice_1 = require("../../features/ticket/ticketSlice");
const CommentsContainer = ({ ticket, comments }) => {
    const dispatch = useAppDispatch_1.default();
    const [commentText, setCommentText] = react_1.useState('');
    const [addComment, setAddComment] = react_1.useState(false);
    const buttonStyle = [styles_1.default.marginTwenty, styles_1.default.alignCenterCenter, { width: 400 }];
    const onCreateComment = () => {
        if (commentText !== '') {
            dispatch(ticketSlice_1.createComment({
                text: commentText,
                ticket_id: ticket.id,
            }));
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexWrap, styles_1.default.flexOne] }, comments && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, { minWidth: 400, paddingBottom: 20 }] },
            react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground, styles_1.default.marginTen] },
                react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Comments", titleNumberOfLines: 255, subtitleNumberOfLines: 255, titleStyle: styles_1.default.textColorBlack, subtitleStyle: { color: colors_1.default.FONT_GRAY } }),
                react_1.default.createElement(react_native_paper_1.Card.Content, { style: styles_1.default.flexOne }, comments.length !== 0 ? (comments.map((comment) => (react_1.default.createElement(commentCard_1.default, { key: comment.id, ticket: ticket, comment: comment })))) : (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterCenter, { height: 400 }] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.textBold] }, `No comments found for this ticket. `)))),
                addComment && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_native_paper_1.TextInput, { label: "Add New Comment", numberOfLines: 4, onChangeText: (value) => setCommentText(value), value: commentText, style: [styles_1.default.textInput, styles_1.default.marginTwenty], theme: themes_1.default.textInput, multiline: true }),
                    react_1.default.createElement(react_native_paper_1.Button, { buttonColor: colors_1.default.BLUE, textColor: colors_1.default.WHITE, icon: "comment-plus", mode: "contained", style: buttonStyle, onPress: onCreateComment, disabled: !commentText }, 'Create new comment '))),
                react_1.default.createElement(react_native_paper_1.Button, { buttonColor: !addComment ? colors_1.default.BLUE : colors_1.default.RED, textColor: colors_1.default.WHITE, icon: "comment-plus", mode: "contained", style: buttonStyle, onPress: () => setAddComment(!addComment) }, addComment ? 'Close add new comment ' : 'Add new comment ')))))));
};
exports.default = CommentsContainer;
